import _ from 'lodash'
import type {DocumentManager} from '@wix/document-manager-core'
import type {Pointer} from '@wix/document-services-types'
import type {MasterPageMigrator} from '../dataMigrationRunner'
import type {SchemaExtensionAPI} from '../../../schema/schema'
import * as constants from '../../../../constants/constants'

const {MASTER_PAGE_ID} = constants

const migrateMasterPage = (documentManager: DocumentManager) => {
    const {extensionAPI, pointers, dal} = documentManager

    const systemStylesPointers = pointers.data.getStyleItemsWithPredicate(
        data =>
            data.type === 'TopLevelStyle' &&
            (extensionAPI as SchemaExtensionAPI).schemaAPI.isSystemStyle(data.id) &&
            data.styleType !== 'system',
        MASTER_PAGE_ID
    )

    _.forEach(systemStylesPointers, (pointer: Pointer) => {
        const styleItem = dal.get(pointer)

        dal.set(pointer, {
            ...styleItem,
            styleType: 'system'
        })
    })
}

const name = 'fixMissingStyleTypeInSystemStyle'
const version = 1

export const fixMissingStyleTypeInSystemStyle: MasterPageMigrator = {
    migrateMasterPage,
    name,
    version
}
